<!-- Wrapper for flex -->
<div class="app-wrapper">
	<!-- Application Menu Bar -->
	<header role="banner">
		<a
			id="skip-to-main-link"
			role="link"
			class="skip-to-main-link"
			aria-label="Skip to Main Content"
			tabindex="1"
			(click)="setSkipFocus()"
			(keyup.enter)="setSkipFocus()"
		>
			<span>Skip to Main Content</span>
		</a>
		<mat-toolbar class="app-toolbar {{ menuColor }}">
			<!-- Header Title and Menu Icon -->
			<div class="app-toolbar-section">
				<!-- Toggle Button For Menu -->
				<button
					class="app-menu-button"
					role="button"
					(click)="toggleLeftSidenav()"
					(dblclick)="toggleLeftSidenavMode()"
					*ngIf="showTools"
					aria-label="Main Menu"
					[attr.aria-expanded]="leftSidenavOpened"
				>
					<fa-icon
						id="app-main-menu"
						[icon]="$any(['fass', 'bars'])"
						aria-label="navigation"
						class="{{ secondaryColor }} fa-md"
					></fa-icon>
				</button>
				<!-- this div is a spacer to make the logo appear in the same spot between the login screen and regular HealthTrack-->
				<div class="app-menu-button" style="cursor: default" *ngIf="!showTools"></div>

				<div class="toolbar-icon-container">
					<img
						src="../assets/images/ht-2-lightblue-white-ring.png"
						class="toolbar-icon {{ secondaryColor }} clickable"
						title="HealthTrack Home Page"
						aria-label="HealthTrack Home Page"
						(click)="goHome()"
					/>
				</div>

				<!-- Title -->
				<a
					id="app-title"
					role="link"
					class="clickable"
					tabindex="0"
					(click)="goHome()"
					(keyup.enter)="goHome()"
				>
					<div class="app-title" *ngIf="!isLoggedIn">
						<span class="title-main">
							<span id="title-health" class="title-start-main {{ secondaryColor }}">HEALTH</span>
							<span id="title-track" class="title-end-main {{ secondaryColor }}">TRACK </span>
						</span>
						<span id="title-env" class="title-end-main {{ secondaryColor }}" *ngIf="!environment.production"
							>&nbsp;{{ environment.environmentName }}</span
						>
					</div>
					<div *ngIf="isLoggedIn" id="app-name" class="app-name {{ secondaryColor }}">
						{{ environment.appTitleOverride || app?.application?.name }}
					</div>
				</a>
			</div>

			<!-- Contract Menu -->
			<mat-menu #contractMenu="matMenu">
				<button mat-menu-item *ngFor="let application of applications" (click)="setApplication(application)">
					<fa-icon
						[icon]="$any(['fass', 'check'])"
						class="mr-sm primary-color"
						[ngStyle]="{ visibility: application == app ? 'visible' : 'hidden' }"
					></fa-icon>
					<span class="primary-color">{{ application.application.name }}</span>
				</button>
			</mat-menu>

			<!-- Notification Menu -->
			<mat-menu #notificationMenu="matMenu" class="notification-menu-panel" (closed)="markRead()">
				<ng-template matMenuContent>
					<div id="app-notification-none" class="notification" *ngIf="notifications?.length == 0">
						No notifications right now
					</div>
					<div
						style="text-align: center"
						id="app-notification-clear-all"
						*ngIf="notifications?.length > 0"
						class="notification notification-clickable"
						(click)="dismissAllNotifications()"
					>
						Dismiss All
					</div>
					<div
						id="app-notification-{{ i }}"
						class="notification"
						*ngFor="let notification of notifications; let i = index"
						(click)="notificationClick(notification)"
						[ngClass]="{
							'notification-clickable': notification.url || notification.click || notification.sidebar,
							'notification-read': notification.isRead
						}"
					>
						<!-- Flex Div for alignment-->
						<div style="display: flex; flex-direction: row; flex-wrap: nowrap">
							<!-- Title Wrapper-->
							<div style="flex: 1 1 auto">
								<div class="notification-title">{{ notification?.subject }}</div>
								<div class="notification-date">{{ notification?.createdDate | momentFromNow }}</div>
							</div>

							<!-- Dismiss notification button-->
							<fa-icon
								[icon]="$any(['fass', 'times'])"
								class="clickable notification-dismiss"
								style="vertical-align: top"
								(click)="dismissNotification(notification, $event)"
								*ngIf="!notification.disableClose"
							></fa-icon>
						</div>

						<!-- Notification Description -->
						<div [innerHTML]="notification?.message"></div>

						<!-- Progress Bars -->
						<mat-progress-bar
							class="notification-progress"
							mode="indeterminate"
							color="accent"
							*ngIf="notification.progressType == 1"
						></mat-progress-bar>
						<mat-progress-bar
							class="notification-progress"
							mode="determinate"
							color="accent"
							[value]="notification.progress"
							*ngIf="notification.progressType == 2"
						></mat-progress-bar>
					</div>
				</ng-template>
			</mat-menu>

			<!-- Settings Menu -->
			<mat-menu #settingsMenu="matMenu" backdropClass="settings-backdrop">
				<span mat-menu-item disabled style="opacity: 1; padding: 0">
					<div class="app-menu-user">
						<!-- Profile Picture -->
						<app-user-profile-pic
							class="app-menu-profile-pic"
							(click)="userProfile()"
							[userId]="user?.userId"
							[appStyle]="{ width: '42px' }"
							matTooltip="User Profile"
						></app-user-profile-pic>

						<!-- User Details -->
						<div class="app-menu-user-details">
							<!-- User's Name -->
							<div id="app-menu-users-name" class="app-menu-users-name primary-color">
								{{ user?.firstName }} {{ user?.lastName }}
							</div>

							<!-- User's Email -->
							<div id="app-menu-users-email" class="app-menu-users-email primary-color">
								{{ user?.email }}
							</div>
						</div>
					</div>
				</span>

				<button *appPermissionId="55" mat-menu-item (click)="openUserSettings()">
					<!-- Display Text-->
					<span id="user-settings-title" class="primary-color">User Settings</span>
				</button>

				<button mat-menu-item [matMenuTriggerFor]="contractMenu" class="primary-color">
					<!-- Display Text-->
					<span id="user-settings-title" class="primary-color">Switch Contracts</span>
				</button>

				<button mat-menu-item (click)="logout()">
					<!-- Display Text-->
					<span id="user-settings-title" class="primary-color">Sign Out</span>
				</button>
			</mat-menu>

			<div class="app-toolbar-filler" *ngIf="showTools" (click)="toggleLeftSidenav(true)">&nbsp;</div>

			<!--<div class="app-toolbar-section-search" *ngIf="showTools" (click)="toggleLeftSidenav(true)">


			</div>-->
			<!-- Header Icon Buttons -->
			<div class="app-toolbar-section-tools" *ngIf="showTools" (click)="toggleLeftSidenav(true)">
				<!-- Search Box -->
				<ng-container *appPermissionId="6">
					<input
						id="app-search-box"
						class="app-search-box large-mode-search-bar"
						type="text"
						[(ngModel)]="searchText"
						placeholder="Search"
						maxlength="100"
						(keyup.enter)="search()"
						*ngIf="showSearch"
						onfocus="this.setSelectionRange(0, this.value.length)"
						autocomplete="off"
					/>
					<fa-icon [icon]="$any(['fass', 'magnifying-glass'])" class="magnify-glass"></fa-icon>
				</ng-container>
				<!-- New Call Button -->
				<ng-container *appPermissionId="33">
					<button
						id="app-new-call"
						class="app-menu-button {{ secondaryColor }}"
						aria-label="New Inbound Call Encounter"
						(click)="newEncounter(1, 4)"
						*ngIf="showNewCall && !encounterInProgress && !roleBasedEncounters"
						matTooltip="New Call"
					>
						<fa-icon [icon]="$any(['fass', 'phone'])"></fa-icon>
					</button>

					<div *ngFor="let role of encounterRoles; let i = index">
						<ng-container *appPermissionId="role.permissionId">
							<button
								id="{{ role.elementId || 'app-new-call' }}"
								class="app-menu-button {{ secondaryColor }}"
								[attr.aria-label]="role.toolTip"
								(click)="
									newEncounter(
										role.primaryEncounterTypeId ? role.primaryEncounterTypeId : 1,
										role.secondaryEncounterTypeId
									)
								"
								*ngIf="showNewCall && !encounterInProgress && roleBasedEncounters"
								[matTooltip]="role.toolTip"
							>
								<fa-icon [icon]="$any(['fass', 'phone'])"></fa-icon>
							</button>
						</ng-container>
					</div>
				</ng-container>

				<!-- In person Button -->
				<ng-container *appPermissionId="35">
					<button
						id="app-in-person-call"
						class="app-menu-button {{ secondaryColor }}"
						[attr.aria-label]="altInPersonLabel ? altInPersonLabel : 'New In-person Call'"
						(click)="newEncounter(30)"
						*ngIf="showNewInPerson && !encounterInProgress"
						matTooltip="{{ altInPersonLabel ? altInPersonLabel : 'New In-person Call' }}"
					>
						<fa-icon [icon]="$any(['fass', 'user-friends'])"></fa-icon>
					</button>
				</ng-container>

				<ng-container *appPermissionId="33">
					<button
						id="app-resume-call"
						class="app-menu-button {{ secondaryColor }}"
						aria-label="Resume Encounter"
						(click)="resumeEncounter()"
						*ngIf="showNewCall && !encounterInProgress && !hideResumeEncounter"
						matTooltip="Resume Encounter"
					>
						<fa-icon [icon]="$any(['fass', 'play'])"></fa-icon>
					</button>
				</ng-container>

				<!-- Encounter in progress button -->
				<button
					id="app-in-progress-call"
					class="app-menu-button {{ secondaryColor }}"
					aria-label="Encounter in progress"
					(click)="returnToEncounter()"
					*ngIf="encounterInProgress"
					matTooltip="In Progress"
					style="padding-right: 0px"
				>
					<fa-icon [icon]="$any(['fass', 'user-headset'])"></fa-icon>
				</button>

				<!--Encounter Timer-->
				<div
					class="{{ secondaryColor }} timer"
					[fxShow]="encounterInProgress"
					(click)="returnToEncounter()"
					role="button"
				>
					<countup-timer></countup-timer>
				</div>

				<!-- Notification Button - adjusted padding to account for unread notifications count -->
				<button
					id="app-notification-menu"
					class="app-menu-button {{ secondaryColor }}"
					style="padding-bottom: 0px; padding-right: 0px"
					aria-label="Notifications"
					matTooltip="Notifications"
					matBadge="{{ unreadNotificationCount }}"
					matBadgeSize="small"
					matBadgeColor="accent"
					[matBadgeHidden]="unreadNotificationCount == 0"
					matBadgePosition="below after"
					[matMenuTriggerFor]="notificationMenu"
					*ngIf="showNotifications"
				>
					<fa-icon [icon]="$any(['fass', 'bell'])"></fa-icon>
				</button>

				<!-- Settings Button - adjusted padding to maintain equal separation due to custom padding setting for notification button -->
				<button
					id="app-settings"
					class="app-menu-button {{ secondaryColor }}"
					style="padding-left: 18px"
					aria-label="Settings"
					matTooltip="Settings"
					[matMenuTriggerFor]="settingsMenu"
					*ngIf="showSettings"
				>
					<!-- Profile Picture -->
					<app-user-profile-pic
						id="app-profile-pic"
						class="app-menu-profile-pic {{ secondaryColor }}"
						style="flex: 0 0 auto"
						[userId]="user?.userId"
						[appStyle]="{ width: '28px' }"
					></app-user-profile-pic>
				</button>
			</div>
		</mat-toolbar>
		<div
			id="non-prod-header"
			role="banner"
			class="non-prod-header"
			*ngIf="!environment.production"
			(click)="toggleLeftSidenav(true)"
		>
			<span>{{ nonProdMessage }}</span>
		</div>
		<div
			id="user-activity-banner"
			role="status"
			class="user-activity-warning-banner"
			*ngIf="showUserActivityBanner"
		>
			<span class="banner-message">
				{{ attendedRPAUserInactiveMessage }}
				<button
					mat-icon-button
					class="banner-refresh-button"
					[disabled]="isRefreshButtonDisabled()"
					[matTooltip]="getRefreshButtonTooltip()"
					(click)="refreshUserActivity()"
					aria-label="Refresh status"
				>
					<fa-icon
						[icon]="['fass', 'sync-alt']"
						[animation]="isRefreshingActivity ? 'spin' : undefined"
						class="refresh-icon"
					></fa-icon>
				</button>
			</span>
		</div>
	</header>

	<!-- Application Container -->
	<mat-sidenav-container autosize id="container">
		<!-- Application Menu -->
		<mat-sidenav
			[mode]="appMenuMode"
			[(opened)]="leftSidenavOpened"
			class="app-menu"
			(closedStart)="leftSidenavClosing()"
			position="start"
		>
			<nav aria-label="Main Navigation" role="navigation">
				<app-application-menu
					[menuConfig]="appMenuConfig"
					(menuItemClicked)="menuItemClicked($event)"
					[showHeader]="true"
					[user]="user"
					[isMultiAppUser]="isMultiAppUser"
				>
				</app-application-menu>
			</nav>
		</mat-sidenav>

		<!-- Application Content / Router -->
		<mat-sidenav-content fxLayout="column" class="app-content" role="main">
			<breadcrumb-trail
				*ngIf="
					!currentUrl.includes('encounter') &&
					!currentUrl.includes('script-builder/editor') &&
					!currentUrl.includes('/security/login') &&
					!currentUrl.includes('/security/app') &&
					!currentUrl.includes('/account/') &&
					!currentUrl.includes('/search/quick-search') &&
					!currentUrl.includes('/security/id_token') &&
					!currentUrl.includes('/security/user-profile') &&
					!currentUrl.includes('/security/user-settings') &&
					!currentUrl.includes('/formly/builder') &&
					!currentUrl.includes('/formly/list') &&
					currentUrl != '/' &&
					currentUrl != ''
				"
				class="pl-md"
			></breadcrumb-trail>
			<div
				id="main"
				tabindex="-1"
				[@navigationDefaultAnimation]="o.isActivated ? o.activatedRoute : ''"
				class="full-height-no-min"
			>
				<router-outlet #o="outlet" class="full-height"></router-outlet>
			</div>
		</mat-sidenav-content>

		<!-- Application Right Slider-->
		<mat-sidenav
			ngResizable
			rzHandles="w"
			[rzMinWidth]="400"
			rzContainment="#container"
			[(opened)]="rightSidenavOpened"
			[mode]="'side'"
			position="end"
			class="app-right-container"
			[class.sidenavExpanded]="sidenavExpanded"
			[class.sidenavShrink]="!sidenavExpanded"
			[disableClose]="true"
			[autoFocus]="false"
		>
			<div class="right-sidenav-controls">
				<fa-icon
					*ngIf="sidenavExpanded"
					[icon]="$any(['fass', 'compress'])"
					class="app-right-container-expand clickable fa-lg mr-lg"
					role="button"
					aria-label="Compress"
					aria-expanded="true"
					(click)="expandRightSidenav()"
					(keyup.enter)="expandRightSidenav()"
					(keyup.space)="expandRightSidenav()"
					tabindex="0"
				></fa-icon>
				<fa-icon
					*ngIf="!sidenavExpanded"
					[icon]="$any(['fass', 'expand'])"
					class="app-right-container-expand clickable fa-lg mr-lg"
					role="button"
					aria-label="Expand"
					aria-expanded="false"
					(click)="expandRightSidenav()"
					(keyup.enter)="expandRightSidenav()"
					(keyup.space)="expandRightSidenav()"
					tabindex="0"
				></fa-icon>
				<fa-icon
					[icon]="$any(['fass', 'arrow-right'])"
					class="app-right-container-close clickable fa-lg"
					role="button"
					aria-label="Close"
					(click)="toggleRightSidenav()"
					(keyup.enter)="toggleRightSidenav()"
					(keyup.space)="toggleRightSidenav()"
					tabindex="0"
				></fa-icon>
			</div>
			<router-outlet name="sidebar"></router-outlet>
		</mat-sidenav>
	</mat-sidenav-container>
</div>
